module.exports = __webpack_public_path__ + "img/bell_curve.d08eac6a.png";